// @flow
import moment from 'moment-timezone'
import groupBy from 'ramda/es/groupBy'
import pipe from 'ramda/es/pipe'
import sort from 'ramda/es/sort'
import evolve from 'ramda/es/evolve'
import map from 'ramda/es/map'
import join from 'ramda/es/join'
import toLower from 'ramda/es/toLower'
import toPairs from 'ramda/es/toPairs'
import ascend from 'ramda/es/ascend'
import prop from 'ramda/es/prop'
import move from 'ramda/es/move'
import groupWith from 'ramda/es/groupWith'
import eqBy from 'ramda/es/eqBy'
import both from 'ramda/es/both'
import { Schedule, ScheduleItem } from 'app/dataTypes/cabinet/support/SupportTypes'


type ArrangedSchedule = {
  usualDays: Array<{
    title: string,
    openClose: string,
    lunch: string,
  }>,
  vacancy: string,
}

const groupSchedule = (schedule: Schedule): ArrangedSchedule => {
  const weekdays = moment.weekdays()
  const weekdaysShort = moment.weekdaysShort()

  return pipe(
    toPairs,
    sort(ascend(prop(0))),
    map(([index, value]) => {
      const { working, vacancy, lunch } = value as ScheduleItem
      const hasOpenClose = working instanceof Array && working.length === 2
      const hasLunch = lunch instanceof Array && lunch.length === 2
      const allDay = vacancy ? '' : 'весь день'

      return ({
        title: vacancy ? weekdays[index] : weekdaysShort[index],
        openClose: hasOpenClose ? working.join('–') : allDay,
        lunch: hasLunch ? lunch.join('–') : '',
      })
    }),
    move(0, -1),
    groupBy(({ openClose }) => (
      openClose ? 'usualDays' : 'vacancy'
    )),
    evolve({
      usualDays: pipe(
        groupWith(both(eqBy(prop('openClose')), eqBy(prop('lunch')))),
        map((arr: any) => ({
          title: (arr.length > 2
            ? `${arr[0].title}-${toLower(arr[arr.length - 1].title)}`
            : pipe(map(prop('title')), join(', '))(arr)),
          openClose: arr[0].openClose,
          lunch: arr[0].lunch,
        }))
      ),
      vacancy: pipe(
        map(pipe(prop('title'), toLower)),
        join(', ')
      ),
    })
  )(schedule)
}

export default groupSchedule
